/**
 * Token UI bám Access form Futures (`form_frmFuturesMain.txt`, subform datasheet).
 * Không thể 1:1 pixel trên web; mục tiêu: cảm giác form/ datasheet / tab control cổ điển Windows-Access.
 */
export const FUTURES_ACCESS_FONT =
  '"Segoe UI", Calibri, "Franklin Gothic Medium", Tahoma, "MS Sans Serif", sans-serif'

/** ~ Access DatasheetFontHeight 11 + Caption */
export const futuresAccessBaseSx = {
  fontFamily: FUTURES_ACCESS_FONT,
  fontSize: '11px',
  color: '#000000',
} as const

/** Vùng client form (màu vùng chi tiết Access cổ điển) */
export const futuresAccessFormBg = '#ECE9D8'

export const futuresAccessTitleBarSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 1,
  px: 1.25,
  py: 0.75,
  bgcolor: futuresAccessFormBg,
  border: '1px solid #919B9C',
  boxShadow: 'inset 1px 1px 0 #FFFFFF, inset -1px -1px 0 #ACA899',
  ...futuresAccessBaseSx,
} as const

export const futuresAccessCaptionSx = {
  fontFamily: FUTURES_ACCESS_FONT,
  fontSize: '13px',
  fontWeight: 700,
  color: '#000000',
  letterSpacing: '0.01em',
} as const

/** Thanh lệnh dưới caption — giống hàng nút trên form Access */
export const futuresAccessCommandBarSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: 0.5,
  px: 1,
  py: 0.5,
  bgcolor: '#E7E7E7',
  border: '1px solid #919B9C',
  borderTop: 'none',
  '& .MuiButton-root': {
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
    textTransform: 'none',
    minHeight: 22,
    py: 0.25,
    px: 1,
    lineHeight: 1.2,
    color: '#000',
    bgcolor: '#E1E1E1',
    border: '1px solid #696969',
    borderRadius: 0,
    boxShadow: 'inset -1px -1px 0 #A0A0A0, inset 1px 1px 0 #FFFFFF',
    '&:hover': { bgcolor: '#d4d4d4', boxShadow: 'inset -1px -1px 0 #A0A0A0, inset 1px 1px 0 #FFFFFF' },
    '&:disabled': { opacity: 0.5 },
  },
  '& .MuiButton-outlined': {
    border: '1px solid #696969',
    bgcolor: '#E1E1E1',
  },
  '& .MuiButton-contained': {
    bgcolor: '#E1E1E1',
    color: '#000',
    boxShadow: 'inset -1px -1px 0 #A0A0A0, inset 1px 1px 0 #FFFFFF',
  },
} as const

/** Tab strip kiểu tab control (chưa chọn xám, chọn nền form) */
export const futuresAccessTabsSx = {
  minHeight: 28,
  bgcolor: '#D4D0C8',
  border: '1px solid #919B9C',
  borderBottom: 'none',
  '& .MuiTabs-flexContainer': { gap: 0.25 },
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTab-root': {
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
    textTransform: 'none',
    minHeight: 26,
    py: 0.25,
    px: 1,
    color: '#000',
    border: '1px solid transparent',
    borderBottom: 'none',
    borderRadius: '3px 3px 0 0',
    opacity: 1,
    '&.Mui-selected': {
      bgcolor: futuresAccessFormBg,
      borderColor: '#919B9C',
      borderBottom: `2px solid ${futuresAccessFormBg}`,
      fontWeight: 600,
    },
  },
} as const

export const futuresAccessTabPanelSx = {
  flex: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
  bgcolor: futuresAccessFormBg,
  border: '1px solid #919B9C',
  borderTop: 'none',
  ...futuresAccessBaseSx,
} as const

/** Nhãn phân nhóm tab (nav chính vs Summary). */
export const futuresAccessTabSectionLabelSx = {
  px: 0.75,
  py: 0.35,
  fontSize: '10px',
  fontWeight: 700,
  fontFamily: FUTURES_ACCESS_FONT,
  color: '#1a1a1a',
  bgcolor: '#C8C6C4',
  border: '1px solid #919B9C',
  borderBottom: 'none',
  mt: 0.5,
} as const

/** Lưới datasheet: header xám, viền ô, footer */
export const futuresAccessDataGridSx = {
  borderRadius: 0,
  border: '1px solid #7A97B8',
  fontFamily: FUTURES_ACCESS_FONT,
  fontSize: '11px',
  bgcolor: '#FFFFFF',
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: '#D4D0C8',
    borderBottom: '1px solid #808080',
  },
  '& .MuiDataGrid-columnHeaderTitle': { fontWeight: 600, fontSize: '11px' },
  '& .MuiDataGrid-cell': {
    borderRight: '1px solid #D0D0D0',
    borderBottom: '1px solid #E8E8E8',
  },
  '& .MuiDataGrid-row:hover': { backgroundColor: 'rgba(173, 214, 255, 0.28)' },
  '& .MuiDataGrid-footerContainer': {
    borderTop: '1px solid #808080',
    backgroundColor: '#D4D0C8',
    minHeight: 40,
  },
  '& .MuiTablePagination-toolbar': { minHeight: 32, fontSize: '11px' },
} as const

/** Toolbar CRUD trong subform — cùng style nút lệnh */
export const futuresAccessToolbarWrapSx = {
  ...futuresAccessBaseSx,
  '& .MuiButton-root': {
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
    textTransform: 'none',
    minHeight: 24,
    color: '#000',
    bgcolor: '#E1E1E1',
    border: '1px solid #696969',
    borderRadius: 0,
    boxShadow: 'inset -1px -1px 0 #A0A0A0, inset 1px 1px 0 #FFFFFF',
    '&:hover': { bgcolor: '#d4d4d4' },
  },
  '& .MuiButton-contained': {
    bgcolor: '#E1E1E1',
    color: '#000',
  },
  '& .MuiButton-outlined': { border: '1px solid #696969' },
  '& .MuiFormControlLabel-root': { marginRight: 1, marginLeft: 0 },
  '& .MuiFormControlLabel-label': { fontSize: '11px', fontFamily: FUTURES_ACCESS_FONT },
  '& .MuiTypography-root': { fontFamily: FUTURES_ACCESS_FONT, fontSize: '11px' },
  '& .MuiTextField-root': {
    '& .MuiInputLabel-root': { fontSize: '11px', fontFamily: FUTURES_ACCESS_FONT },
    '& .MuiOutlinedInput-root': {
      fontSize: '11px',
      bgcolor: '#FFFFFF',
      borderRadius: 0,
      '& fieldset': { borderColor: '#7A7A7A' },
    },
  },
} as const

export const futuresAccessSearchFieldSx = {
  minWidth: 220,
  '& .MuiInputLabel-root': { fontSize: '11px', fontFamily: FUTURES_ACCESS_FONT },
  '& .MuiOutlinedInput-root': {
    fontSize: '11px',
    bgcolor: '#FFFFFF',
    borderRadius: 0,
    '& fieldset': { borderColor: '#7A7A7A' },
  },
} as const

/** Popup form Access — viền góc vuông, nền form */
export const futuresAccessDialogPaperProps = {
  sx: {
    borderRadius: 0,
    border: '2px solid #919B9C',
    boxShadow: '4px 4px 0 rgba(0,0,0,0.12)',
    bgcolor: futuresAccessFormBg,
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
  },
} as const

export const futuresAccessDialogTitleSx = {
  borderBottom: '1px solid #919B9C',
  bgcolor: '#D4D0C8',
  py: 1,
  px: 1.5,
  fontSize: '13px',
  fontWeight: 700,
  fontFamily: FUTURES_ACCESS_FONT,
} as const

export const futuresAccessDialogActionsSx = {
  borderTop: '1px solid #919B9C',
  bgcolor: '#E7E7E7',
  px: 1.5,
  py: 1,
  gap: 1,
  '& .MuiButton-root': {
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
    textTransform: 'none',
    minHeight: 24,
    borderRadius: 0,
    color: '#000',
    border: '1px solid #696969',
    bgcolor: '#E1E1E1',
    boxShadow: 'inset -1px -1px 0 #A0A0A0, inset 1px 1px 0 #FFFFFF',
    '&:hover': { bgcolor: '#d4d4d4' },
  },
  '& .MuiButton-contained': { bgcolor: '#E1E1E1', color: '#000' },
  '& .MuiButton-contained.MuiButton-colorError': {
    bgcolor: '#ffcccc',
    borderColor: '#8b0000',
  },
} as const

export const futuresAccessDialogContentSx = {
  bgcolor: '#FFFFFF',
  px: 1.5,
  py: 1.25,
  fontFamily: FUTURES_ACCESS_FONT,
  fontSize: '11px',
} as const

/** Nội dung form CRUD — ô nhập góc vuông, nhãn 11px. */
export const futuresAccessCrudDialogContentSx = {
  ...futuresAccessDialogContentSx,
  '& .MuiFormHelperText-root': { fontFamily: FUTURES_ACCESS_FONT, fontSize: '10px' },
  '& .MuiTextField-root .MuiInputLabel-root': { fontSize: '11px', fontFamily: FUTURES_ACCESS_FONT },
  '& .MuiTextField-root .MuiOutlinedInput-root': {
    fontSize: '11px',
    bgcolor: '#FFFFFF',
    borderRadius: 0,
    '& fieldset': { borderColor: '#7A7A7A' },
  },
} as const

/**
 * Dialog + ô nhập giống `/sales/contract/list` (ContractFormDialog).
 * Dùng cho CRUD Futures; flow Access giữ ngữ nghiệp vụ, không bám skin Access trong form.
 */
export const futuresSaleContractDialogPaperProps = {
  sx: {
    maxHeight: 'min(900px, 92vh)',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 1,
  },
} as const

export const futuresSaleContractDialogTitleSx = {
  pb: 1,
  pt: 1.25,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  fontWeight: 700,
  fontSize: '1rem',
  lineHeight: 1.2,
} as const

export const futuresSaleContractDialogContentSx = {
  pt: 0.75,
  px: 2,
  pb: 1.5,
  overflowY: 'auto' as const,
  flex: '1 1 auto',
  minHeight: 0,
  bgcolor: '#FFFFFF',
  '& .MuiInputBase-root': {
    minHeight: 32,
    fontSize: '0.8125rem',
  },
  '& .MuiInputBase-input': {
    py: 0.5,
    fontSize: '0.8125rem',
  },
  '& .MuiInputLabel-root': {
    fontSize: '0.8125rem',
    fontWeight: 500,
  },
  '& .MuiInputLabel-shrink': {
    fontWeight: 600,
  },
  '& .MuiFormControlLabel-label': {
    fontSize: '0.8125rem',
    fontWeight: 500,
  },
  '& .MuiFormHelperText-root': {
    fontSize: '0.6875rem',
  },
  '& .MuiTypography-caption': {
    fontSize: '0.6875rem',
    fontWeight: 600,
    letterSpacing: '0.03em',
    textTransform: 'uppercase' as const,
  },
  '& .MuiTypography-body2': {
    fontSize: '0.8125rem',
  },
  '& .MuiSelect-select': {
    fontSize: '0.8125rem',
  },
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
  },
} as const

export const futuresSaleContractDialogActionsSx = {
  px: 2,
  py: 1,
  gap: 1,
  flexShrink: 0,
  borderTop: 1,
  borderColor: 'divider',
  '& .MuiButton-root': {
    py: 0.25,
    px: 1,
    minHeight: 28,
    fontSize: '0.75rem',
    lineHeight: 1.2,
    textTransform: 'none' as const,
  },
} as const

/**
 * DialogTitle layout cho mọi form New/Edit Futures Control:
 * tiêu đề trái — Save/Cancel pin sát phải (giống FormHeader `btnSave/btnCancel` Access).
 * Dùng cặp với `futuresFormDialogActionBtnSx` cho các nút trong header.
 */
export const futuresFormDialogTitleSx = {
  pb: 1,
  pt: 1.25,
  px: 2,
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexShrink: 0,
  flexWrap: 'nowrap' as const,
} as const

/** Bọc nhóm nút action ở phải trong DialogTitle. */
export const futuresFormDialogActionsBoxSx = {
  display: 'flex',
  gap: 0.5,
  alignItems: 'center',
  ml: 'auto',
  flexShrink: 0,
} as const

/** Save/Cancel button size đồng nhất khi pin trên header. */
export const futuresFormDialogActionBtnSx = {
  py: 0.25,
  px: 1,
  minHeight: 28,
  fontSize: '0.75rem',
  lineHeight: 1.2,
  textTransform: 'none' as const,
} as const

export const futuresAccessToggleGroupSx = {
  '& .MuiToggleButtonGroup-grouped': { borderRadius: '0 !important' },
  '& .MuiToggleButton-root': {
    fontFamily: FUTURES_ACCESS_FONT,
    fontSize: '11px',
    textTransform: 'none',
    py: 0.25,
    px: 1,
    color: '#000',
    border: '1px solid #696969',
    bgcolor: '#E1E1E1',
    '&.Mui-selected': {
      bgcolor: '#FFFFFF',
      fontWeight: 600,
    },
  },
} as const
